import { applyMiddleware, combineReducers, legacy_createStore } from "redux"
import { providerReducer } from "./provider/reducer"
import { thunk } from "redux-thunk"
import { userReducer } from "./Auth/reducer"

const root =  combineReducers({
    providerReducer,userReducer
})

export const store = legacy_createStore(root, applyMiddleware(thunk))